<template>
  <div>
    <base-loading v-if="loading.filter" />
    <v-row v-else align="center" justify="center" class="px-10">
      <v-col class="pa-1" cols="2" sm="2" md="2">
        <v-menu
          v-model="menuDataIni"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="moment(form.dataInicio).format('DD/MM/YYYY')"
              label="Data Inicial"
              prepend-icon="mdi-calendar"
              color="teal"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="form.dataInicio"
            style="margin: 0px"
            color="teal"
            locale="pt-br"
            @input="menuDataIni = false"
          />
        </v-menu>
      </v-col>
      <v-col class="pa-1" cols="2" sm="2" md="2">
        <v-menu
          v-model="menuDataFim"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="moment(form.dataFim).format('DD/MM/YYYY')"
              color="teal"
              label="Data Final"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="form.dataFim"
            :min="form.dataInicio"
            :max="dataLimite"
            color="teal"
            locale="pt-br"
            @input="menuDataFim = false"
          />
        </v-menu>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="filtroStatus"
          autocomplete="autocomplete_off_hack_xfr4!k"
          label="Filtro"
          :items="status"
          item-text="name"
          item-value="value"
          clearable
          required
          @change="changeFiltro"
        />
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="form.consultor"
          autocomplete="autocomplete_off_hack_xfr4!k"
          label="Consultor"
          :items="consultoresFiltrados"
          item-text="Nome"
          item-value="id"
          clearable
          :disabled="loading.consultor"
          :loading="loading.consultor"
          required
          multiple
          @change="limparSupervisor"
        >
          <template v-slot:prepend>
            <v-icon>mdi-account</v-icon>
          </template>

          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < CHIP_LIMIT" outlined small class="caption">
              <span v-if="index < CHIP_LIMIT">
                {{ item.Nome }}
              </span>
            </v-chip>
            <span v-if="index === CHIP_LIMIT" class="grey--text caption">
              (+{{ form.consultor.length - CHIP_LIMIT }}
              outros)
            </span>
          </template>

          <template slot="prepend-item">
            <v-btn
              text
              class="green--text"
              elevation="2"
              color="blue"
              block
              small
              @click="selectAllConsultores"
            >
              SELECIONAR TODOS
            </v-btn>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="2">
        <v-autocomplete
          v-model="form.supervisor"
          autocomplete="autocomplete_off_hack_xfr4!k"
          label="Supervisor"
          :items="supervisoresFiltrados"
          item-text="Nome"
          item-value="id"
          clearable
          :disabled="loading.supervisor"
          :loading="loading.supervisor"
          required
          multiple
          @change="limparConsultor"
        >
          <template v-slot:prepend>
            <v-icon>mdi-account</v-icon>
          </template>

          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < CHIP_LIMIT" outlined small class="caption">
              <span v-if="index < CHIP_LIMIT">
                {{ item.Nome }}
              </span>
            </v-chip>
            <span v-if="index === CHIP_LIMIT" class="grey--text caption">
              (+{{ form.supervisor.length - CHIP_LIMIT }}
              outros)
            </span>
          </template>

          <template slot="prepend-item">
            <v-btn
              text
              class="green--text"
              elevation="2"
              color="blue"
              block
              small
              @click="selectAllSupervisores"
            >
              SELECIONAR TODOS
            </v-btn>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col class="pa-2" cols="2" sm="2" md="2">
        <v-row justify="end" align="center">
          <v-btn
            style="color: white; border-radius: 8px; margin-left: 40%"
            color="green darken-1"
            :disabled="!form.consultor && !form.supervisor"
            @click="search"
          >
            <span style="font-size: 16px; font-weight: 600">Buscar</span>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import consultantService from '../../../services/api/consultant'
import supervisorService from '../../../services/api/supervisor'

export default {
  name: 'VisitFilter',

  data() {
    return {
      loading: {
        filter: false,
        consultor: true,
        supervisor: true,
      },

      searching: true,
      dataLimite: this.moment(this.dataInicio).add(0, 'months').toISOString(),
      menuDataIni: false,
      menuDataFim: false,

      form: {
        user: null,
        consultor: [],
        supervisor: [],
        dataInicio: this.moment()
          .subtract(1, 'months')
          .toISOString(true)
          .substr(0, 10),
        dataFim: this.moment().toISOString(true).substr(0, 10),
      },

      consultores: [{ Nome: 'Carregando', id: 0 }],
      supervisores: [{ Nome: 'Carregando', id: 0 }],
      status: [
        { name: 'Todos', value: null },
        { name: 'Ativos', value: '1' },
        { name: 'Inativos', value: '0' },
      ],
      filtroStatus: null,
      CHIP_LIMIT: 5,
    }
  },
  computed: {
    supervisoresFiltrados() {
      if (!this.filtroStatus) return this.supervisores

      return this.supervisores.filter(s => s.ATIVO === this.filtroStatus)
    },

    consultoresFiltrados() {
      if (!this.filtroStatus) return this.consultores

      return this.consultores.filter(c => c.Status === this.filtroStatus)
    },
  },

  created() {
    this.loadConsultores()
    this.loadSupervisores()
  },

  methods: {
    selectAllConsultores() {
      this.form.consultor = this.consultoresFiltrados.map(
        consultor => consultor.id,
      )
      this.limparSupervisor()
    },

    selectAllSupervisores() {
      this.form.supervisor = this.supervisoresFiltrados.map(
        supervisor => supervisor.id,
      )
      this.limparConsultor()
    },

    changeFiltro() {
      this.limparConsultor()
      this.limparSupervisor()
    },

    async loadConsultores() {
      this.loading.consultor = true
      this.consultores = await consultantService.getConsultores()

      this.loading.consultor = false
    },

    async loadSupervisores() {
      this.loading.supervisor = true
      this.supervisores = await supervisorService.getSupervisores(1, true)

      this.loading.supervisor = false
    },

    limparConsultor() {
      this.form.consultor = []
    },

    limparSupervisor() {
      this.form.supervisor = []
    },

    search() {
      if (this.form.consultor.length == 0 && this.form.supervisor.length == 0) {
        this.Swal.fire({
          title: 'Atenção',
          text: 'Selecione um consultor ou um supervisor',
          icon: 'warning',
          confirmButtonText: 'Ok',
        })
        return
      }

      if (this.form.consultor) {
        this.form.user = this.consultores.find(
          consultor => consultor.id === this.form.consultor,
        )
      } else {
        this.form.user = this.supervisores.find(
          supervisor => supervisor.id === this.form.supervisor,
        )
      }

      this.$emit('search', this.form)
    },
  },
}
</script>
